import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { signs } from '@chronos/astro-lib';
import { signsIcons, signsNames } from './defs';
import { getSectorLength, Group } from './Circle';
import { hideMapInfoPopup, showMapInfoPopup } from './utils';
import { radialPoint } from '@chronos/api';
export default class Zodiacs extends React.Component {
    constructor(props) {
        super(props);
        this._zodiacs = React.createRef();
        this._icons = [];
        this._coloredSectors = [];
        this._hoverArea = [];
        this._coloredCurves = [];
        this.update = (newProps) => {
            requestAnimationFrame(() => {
                if (!this._zodiacs.current)
                    return;
                const { rotation, horarSigns, direction, mode, mapSettings: { personalization } } = newProps;
                const { zodiacs } = personalization.circle;
                const { computedRadius } = newProps;
                const coloredSectorOpacity = () => {
                    if (zodiacs.style === 0) {
                        return 0;
                    }
                    if (zodiacs.style === 1) {
                        return 0.3;
                    }
                    if (zodiacs.style === 2) {
                        return 0.3;
                    }
                    if (zodiacs.style === 3) {
                        return 1;
                    }
                    return 1;
                };
                const externalRadius = newProps.radius * (newProps.hasExt ? computedRadius.zodiacsExternalExt : computedRadius.zodiacsExternal);
                const innerRadius = newProps.radius * (newProps.hasExt ? computedRadius.zodiacsInternalExt : computedRadius.zodiacsInternal);
                const iconsRadius = (externalRadius + innerRadius) / 2;
                const iconSize = newProps.radius * zodiacs.iconSize;
                const sector = (r, a, length) => {
                    if (mode === 'horar' || mode === 'soul') {
                        return {
                            start: radialPoint(newProps.x, newProps.y, r, a + zodiacs.gap / 2),
                            end: radialPoint(newProps.x, newProps.y, r, a + length - zodiacs.gap)
                        };
                    }
                    else {
                        const startA = direction === 'cw' ? -(a - zodiacs.gap / 2) : a + zodiacs.gap / 2;
                        const endA = direction === 'cw' ? -(a - length - zodiacs.gap) : a + length - zodiacs.gap;
                        return {
                            start: radialPoint(newProps.x, newProps.y, r, startA),
                            end: radialPoint(newProps.x, newProps.y, r, endA)
                        };
                    }
                };
                for (let i = 0; i < 12; i++) {
                    const dirCoefficient = (mode === 'horar' || mode === 'soul') ? 0 : (direction === 'cw' ? 30 : 0);
                    const a = horarSigns.length ? 180 + horarSigns[i] : rotation + i * 30 + dirCoefficient;
                    const sectorLength = horarSigns.length ? getSectorLength(i, horarSigns) : 30;
                    const internal = sector(innerRadius, a, sectorLength);
                    const external = sector(externalRadius, a, sectorLength);
                    const g = this._zodiacs.current.childNodes[i];
                    const opacity = !newProps.highlights || newProps.highlights.includes(i) ? 1 : 0.2;
                    g.setAttribute('fill', `rgba(var(--circle-zodiacs-${signs[i].element}-rgb-${personalization.circle.colorThemes.zodiacs.active}), ${opacity})`);
                    const icon = g.lastChild;
                    const iconA = ((mode === 'horar' || mode === 'soul') ? a + sectorLength / 2 : direction === 'cw' ? -(a - sectorLength / 2) : a + sectorLength / 2);
                    const iconPos = radialPoint(newProps.x, newProps.y, iconsRadius, iconA);
                    icon.setAttribute('x', (iconPos.x - iconSize / 2).toString());
                    icon.setAttribute('y', (iconPos.y - iconSize / 2).toString());
                    icon.setAttribute('fill', personalization.circle.zodiacs.style === 3
                        ? `rgba(0, 0, 0, ${opacity})`
                        : `rgba(var(--circle-zodiacs-${signs[i].element}-rgb-${personalization.circle.colorThemes.zodiacs.active}), ${opacity})`);
                    const hover = this._hoverArea[i].current;
                    hover.setAttribute('cx', iconPos.x.toString());
                    hover.setAttribute('cy', iconPos.y.toString());
                    const coloredSector = this._coloredSectors[i].current;
                    coloredSector.setAttribute('fill', `rgba(var(--circle-zodiacs-${signs[i].element}-rgb-${personalization.circle.colorThemes.zodiacs.active}), ${coloredSectorOpacity() * opacity})`);
                    coloredSector.setAttribute('d', `
          M ${internal.start.x} ${internal.start.y}
          A ${innerRadius} ${innerRadius} 0 0 0 ${internal.end.x} ${internal.end.y}
          L ${external.end.x} ${external.end.y}
          A ${externalRadius} ${externalRadius} 0 0 1 ${external.start.x} ${external.start.y}
        `);
                    const coloredCurve = this._coloredCurves[i].current;
                    coloredCurve.setAttribute('display', personalization.circle.zodiacs.style === 0 || personalization.circle.zodiacs.style === 1 ? 'block' : 'none');
                    coloredCurve.setAttribute('stroke', `rgba(var(--circle-zodiacs-${signs[i].element}-rgb-${personalization.circle.colorThemes.zodiacs.active}), ${opacity})`);
                    coloredCurve.setAttribute('d', `
          M ${internal.start.x} ${internal.start.y}
          A ${innerRadius} ${innerRadius} 0 0 0 ${internal.end.x} ${internal.end.y}
        `);
                }
            });
        };
        for (let i = 0; i < 12; i++) {
            this._icons.push(React.createRef());
            this._coloredSectors.push(React.createRef());
            this._hoverArea.push(React.createRef());
            this._coloredCurves.push(React.createRef());
        }
    }
    shouldComponentUpdate(newProps) {
        this.update(newProps);
        return !!newProps.isEditor || newProps.mode !== this.props.mode || newProps.mapSettings.personalization.name !== this.props.mapSettings.personalization.name;
    }
    componentDidMount() {
        this.update(this.props);
    }
    render() {
        var _a, _b, _c, _d, _e, _f;
        const { props } = this;
        const { zodiacs } = props.mapSettings.personalization.circle;
        const iconSize = props.radius * zodiacs.iconSize;
        const elements = [];
        for (let i = 0; i < 12; i++) {
            const Icon = signsIcons[i];
            elements.push(_jsxs(Group, { id: `sign-sector-${(_c = (_b = (_a = this.props.mapSettings).t) === null || _b === void 0 ? void 0 : _b.call(_a, signs[i].en)) !== null && _c !== void 0 ? _c : signs[i].en}`, onMouseEnter: (ev) => {
                    var _a;
                    if (props.mapSettings.access.limited)
                        return false;
                    const _t = this.props.mapSettings.t;
                    const signName = `${(_a = _t === null || _t === void 0 ? void 0 : _t(signs[i].en)) !== null && _a !== void 0 ? _a : signsNames[i].ru}`;
                    showMapInfoPopup(ev.target.parentElement.querySelector('.signIcon'), [signName], ev);
                }, onMouseLeave: _ => {
                    hideMapInfoPopup();
                }, onClick: () => this.props.onHelp('signs', i), children: [_jsx("path", { ref: this._coloredSectors[i] }), _jsx("path", { ref: this._coloredCurves[i], strokeWidth: 2, fill: "none" }), _jsx("circle", { ref: this._hoverArea[i], r: iconSize, fill: "transparent", stroke: "transparent" }), _jsx(Icon, { className: 'signIcon', stroke: "none", fill: "inherit", width: iconSize, height: iconSize, overflow: "visible", id: `sign-sector-icon-${(_f = (_e = (_d = this.props.mapSettings).t) === null || _e === void 0 ? void 0 : _e.call(_d, signs[i].en)) !== null && _f !== void 0 ? _f : signs[i].en}` })] }, `zodiac_${this.props.mode}_${i}`));
        }
        return (_jsx(Group, { ref: this._zodiacs, children: elements }));
    }
}
